import React, { useState, useEffect } from "react";

const TokenDescriptionModal = ({ onSave, data }) => {
  const [tokenPotData, setTokenPotData] = useState({});
  useEffect(() => {
    if (data) {
      setTokenPotData({ ...data });
    }
  }, [data]);
  const updatePotDescription = ({ target }) => {
    setTokenPotData({ ...tokenPotData, text: target.value });
  };
  return (
    <div
      className="modal fade token-description-modal"
      id="token-description-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Token Description</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <div
              style={{
                marginBottom: 10,
              }}
            >
              <h5 className="section-title">Description</h5>
              <textarea
                className="form-control form-control-md "
                placeholder="Input token description name here..."
                onChange={updatePotDescription}
                value={tokenPotData.text}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-orange"
              data-dismiss="modal"
            >
              Later
            </button>
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              disabled={!tokenPotData.text}
              onClick={() => onSave(tokenPotData)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TokenDescriptionModal;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/TokenDescriptionModal.js